import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject, ViewChild, TemplateRef } from '@angular/core';
import {DOCUMENT} from '@angular/common';


@Component({
  selector: 'app-custom-dialogs',
  templateUrl: './custom-dialogs.component.html',
  styleUrls: ['./custom-dialogs.component.css']
})
export class CustomDialogsComponent implements OnInit {
	title: string;
  	message: string;
  	defaultDialogConfig = new MatDialogConfig();

  _dialogRef: MatDialogRef<CustomDialogsComponent> | null;
  lastAfterClosedResult: string;
  lastBeforeCloseResult: string;
  actionsAlignment: string;
  config = {
    disableClose: false,
    panelClass: 'custom-overlay-pane-class',
    hasBackdrop: true,
    backdropClass: '',
    width: '400',
    height: '',
    minWidth: '',
    minHeight: '',
    maxWidth: this.defaultDialogConfig.maxWidth,
    maxHeight: '',
    position: {
      top: '',
      bottom: '',
      left: '',
      right: ''
    },
    data: {
	  title: 'Confirm Action',
      message: 'Are you sure ?'
    }
  };
  numTemplateOpens = 0;

 // @ViewChild(TemplateRef) template: TemplateRef<any>;

  constructor(public dialog: MatDialog/**, @Inject(DOCUMENT) doc: any,   */
  		/**private dialogRef: MatDialogRef<CustomDialogsComponent>, @Inject(MAT_DIALOG_DATA) public data: any*/) {
    // Possible useful example for the open and closeAll events.
    // Adding a class to the body if a dialog opens and
    // removing it after all open dialogs are closed
  /**  dialog.afterOpened.subscribe(() => {
      if (!doc.body.classList.contains('no-scroll')) {
        doc.body.classList.add('no-scroll');
      }
    });
    dialog.afterAllClosed.subscribe(() => {
      doc.body.classList.remove('no-scroll');
    }); */
  }
 
  ngOnInit(): void {
  }
  
  showConfirmCustom(){
	  this.title = this.config.data.title;
	  this.message = this.config.data.message;
	  
	  this._dialogRef = this.dialog.open(CustomDialogsComponent, this.config);
	console.log(this.defaultDialogConfig.maxWidth);
	console.log(this.config);
    this._dialogRef.beforeClosed().subscribe((result: string) => {
      this.lastBeforeCloseResult = result;
      console.log('beforeClosed: '+result)
    });
    this._dialogRef.afterClosed().subscribe((result: string) => {
      this.lastAfterClosedResult = result;
      //this.dialogRef = null;
      console.log('afterClosed')
    });
  }
  
  
  /**
  constructor(public dialogRef: MatDialogRef<CustomDialogsComponent>,
 	 public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: CustomDialogsModel) {
    // Update view with given values
    this.title = data.title;
    this.message = data.message;
  }
  
  */
  

	onConfirm(): void {
    // Close the dialog, return true
   // this.dialogRef.close(true);
    console.log('close via OnConfirm')
  }

  onDismiss(): void {
    // Close the dialog, return false
    this._dialogRef.close(false);
  }

 

}

/**
export class CustomDialogsModel {

  constructor(public title: string = "Confirm Action", public message: string = "Are you sure ??") {
  }
}
*/